import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import { withRouter } from 'react-router';

import {
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    InputGroup,
    Container
} from 'reactstrap';
import { colorTheme, OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';

import {
    check_empty_field,
    check_if_number

} from './validationChecks';
import CustomLabel from '../../components/CustomLabel';

import {
    OtherRecurringBills,
    handleChangeBillsAmount,
    handleChangeBillsOptions,
    getBillsItems,
    getBillsOptions,
    getBillsName,
    handleAddItem,
    handleDeleteItem,
    isValidBillsItems
} from '../../components/OtherRecurringBills';

import {
    addUnit,
    updateUnit,
    deleteUnit,
    showLoading,
    showFeatureComingSoon,
    fetchOptions,
    fetchPropertiesUnitsTenants
} from '../../redux/actions';

import CustomPropertySelect from '../../components/CustomPropertySelect';
import CustomInput from '../../components/CustomInput';
import { IonIcon, IonButton } from '@ionic/react';
import { trashOutline } from 'ionicons/icons';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        options: state.options
    };
}

const mapDispatchToProps = {
    addUnit,
    updateUnit,
    deleteUnit,
    showLoading,
    showFeatureComingSoon,
    fetchOptions,
    fetchPropertiesUnitsTenants
};

class UnitsForm extends React.Component{
    constructor(props) {
        super(props);

        this.tenantFormButtonRef = React.createRef();

        let unit = {
            propertyId: Object.values(this.props.properties).length === 1 ?  Object.values(this.props.properties)[0].propertyId : "",
            unitId: "",
            unitName: "",
            rentAmount: "",
            occupied: false,
            notes: "",
            taxRate: "",
            showUploadSpreadSheet: props.showUploadSpreadSheet == false? false: true,
            otherRecurringBillsItems:[{ bill: [], amount: ""}],
            otherRecurringBillsItemOptions: []
        };

        this.state = {
            ...unit,
            properties: [],
            numErrors: 0,
            errors: {
                unitName: "",
                rentAmount: "",
                taxRate: "",
                otherRecurringBillsItems: unit.otherRecurringBillsItems.map( () => ({bill: [], amount: ""})),
                notes: "",
            }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setUnitValues = this.setUnitValues.bind(this);
        this.handleChangeBillsAmount = handleChangeBillsAmount.bind(this);
        this.handleChangeBillsOptions = handleChangeBillsOptions.bind(this);
        this.getBillsItems = getBillsItems.bind(this);
        this.getBillsName = getBillsName.bind(this);
        this.getBillsOptions = getBillsOptions.bind(this);
        this.handleAddItem = handleAddItem.bind(this);
        this.handleDeleteItem = handleDeleteItem.bind(this);
        this.isValidBillsItems = isValidBillsItems.bind(this);
    }

    async fetchInitialData() {
        await Promise.all([
          (async () => {
            if (_.isEmpty(this.props.options)) {
              this.props.showLoading(true);
              await this.props.fetchOptions();
            }
          })(),
          (async () => {
            if (_.isEmpty(this.props.properties)) {
              this.props.showLoading(true);
              await this.props.fetchPropertiesUnitsTenants();
            }
          })(),
        ]);
      }

    async componentDidMount(){
        await this.fetchInitialData();

        let unitProps = this.props.unit;

        await new Promise(resolve => {
            this.setState({
                propertyId: unitProps ? unitProps.propertyId : this.state.propertyId,
                unitId: unitProps ? unitProps.unitId : this.state.unitId,
                unitName: unitProps ? unitProps.unitName : this.state.unitName,
                rentAmount: unitProps ? unitProps.rentAmount : this.state.rentAmount,
                occupied: unitProps ? unitProps.occupied : this.state.occupied,
                taxRate: unitProps ? unitProps.taxRate : this.state.taxRate,
                notes: unitProps ? unitProps.notes : this.state.notes,
                properties: Object.values(this.props.properties),
                otherRecurringBillsItems: unitProps && unitProps.otherRecurringBillsItems && unitProps.otherRecurringBillsItems.length > 0 ? unitProps.otherRecurringBillsItems.map(this.getBillsItems.bind(this)) : this.state.otherRecurringBillsItems,
                otherRecurringBillsItemOptions: unitProps ? this.getBillsOptions((unitProps.otherRecurringBillsItems).map(this.getBillsItems.bind(this)), unitProps.otherRecurringBillsItems, this.props.options) : (this.props.options.otherRecurringBillItems).map(getBillsName.bind(this))
            }, resolve);
        });
        // Mixpanel.track("Units form: mounted");
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.unitId && this.props.unitId) {
            //added this so the users are shown the add tenant button via scrolling to it which they would have otehrwise missed
          this.scrollToTenantFormButton();
        }
      }

      scrollToTenantFormButton() {
        if (this.tenantFormButtonRef.current) {
          this.tenantFormButtonRef.current.scrollIntoView({ behavior: 'auto' });
        }
      }

    validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];

        switch(name){
            case "unitName":
                checks = [check_empty_field]
                break;
            case "rentAmount":
                checks = [check_empty_field, check_if_number]
                break;
            case "taxRate":
                checks = [check_if_number]
                break;
            default:
                break;
        }
        for (let index in checks){
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0){
                if (previousError.length == 0){
                    this.setState((prevState)=>({numErrors: prevState.numErrors + 1}));
                }
                isValid = false;
                break;
            }else if(previousError.length > 0){
                this.setState((prevState)=>({numErrors: prevState.numErrors - 1}));
            }
        }
        return isValid;
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});

        this.validateInput(name, val);
    }

    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["unitName", "rentAmount", "taxRate"];
        let invalid_fields = fields.filter((field)=> !(this.validateInput(field, this.state[field])));
        const isValidBillItems= await isValidBillsItems(this.state.otherRecurringBillsItems, this.setState.bind(this));
        if (this.state.propertyId != "" && invalid_fields.length == 0 && isValidBillItems) {
            const otherRecurringBillsItems = this.state.otherRecurringBillsItems.filter(
                otherRecurringBillsItems => otherRecurringBillsItems.bill.length > 0 && otherRecurringBillsItems.amount.length > 0
            ).map(otherRecurringBillsItems => ({
                bill: otherRecurringBillsItems.bill[0].id || otherRecurringBillsItems.bill[0],
                amount: otherRecurringBillsItems.amount
            }));
            this.props.showLoading(true);
            let result;
            let unitPayload = {
                propertyId: this.state.propertyId,
                unitId: this.state.unitId,
                unitName: this.state.unitName,
                rentAmount: this.state.rentAmount,
                occupied: this.state.occupied,
                taxRate: this.state.taxRate || 0,
                otherRecurringBillsItems,
                notes: this.state.notes
            };
            if (this.state.unitId){
                this.props.updateUnit(unitPayload);
            }else{
                result = await this.props.addUnit(unitPayload);

                if(result && result.payload){
                    let unitId = result.payload.unitId;
                    this.setState({
                        unitId,
                        otherRecurringBillsItems: result.payload.otherRecurringBillsItems.length > 0 ? result.payload.otherRecurringBillsItems.map(this.getBillsItems.bind(this)) : [{ bill: [], amount: ""}],
                        errors: {
                            ...this.state.errors,
                            otherRecurringBillsItems: result.payload.otherRecurringBillsItems.map((item) => ({bill: "", amount: ""}))
                        }
                    });
                }
            }
        }
        Mixpanel.track("Unit form: submit btn");
    }


    setUnitValues({
        propertyId = "",
        unitId = "",
        unitName = "",
        rentAmount = "",
        occupied = false,
        taxRate = "0",
        notes = "",
        otherRecurringBillsItems = [{ bill: [], amount: "" }],
    } = {}) {
        window.scrollTo(0, 0);
        const otherRecurringBillsItemOptions = this.getBillsOptions([],[], this.props.options);
        this.setState({
            propertyId,
            unitId,
            unitName,
            rentAmount,
            occupied,
            taxRate,
            notes,
            otherRecurringBillsItems,
            otherRecurringBillsItemOptions,
        });
    }

    handleAddNewUnit(event){
        event.preventDefault();
        this.setUnitValues({propertyId: this.state.propertyId});
        Mixpanel.track("Units form: add new unit");
    }


    handleClear(event){
        event.preventDefault();
        this.setUnitValues();
        Mixpanel.track("Units form: clear btn");
    }

    handleDelete(propertyId, unitId, event) {
        event.preventDefault();
        const confirmDelete = window.confirm(`Are you sure you want to delete this unit?`);

        if (confirmDelete) {
            this.props.showLoading(true);
            this.setUnitValues({propertyId});
            this.props.deleteUnit(propertyId, unitId);
            Mixpanel.track("Units form: delete btn");
        }
    }


    onClickUploadSpreadSheet(event){
        event.preventDefault();
        this.props.showFeatureComingSoon();
        Mixpanel.track("Units form: upload spreadsheet btn");
    }

    async handleTenantFormButton(event) {
        event.preventDefault();
        if (this.state.unitId) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const url = searchParams.has('tutorial') ? `${UNIFORM_RESOURCE_LOCATORS.tenantForm}?tutorial&propertyId=${this.state.propertyId}&unitId=${this.state.unitId}`:
            `${UNIFORM_RESOURCE_LOCATORS.tenantForm}?propertyId=${this.state.propertyId}&unitId=${this.state.unitId}`;

            await this.props.history.push(url);
        }
      }

    renderTenantFormButton(){
        return(
            <Button className="bg-white"
                style={{borderColor: colorTheme["primary"]["700"], color: colorTheme["primary"]["700"], animation: 'pulse 2s 3', marginRight: "3em"}}
                onClick={this.handleTenantFormButton.bind(this)}
                data-testid="addTenantFormButton"
            >
                Add {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}(s){" "}
                <i className="fa fa-arrow-right mr-2"></i>
            </Button>
        )
    }

    render() {
        return (
            <Container>
            <Col md={12} className='ml-5'>
                <Row className="mb-3">

                    <Col lg={3} md={4} sm={4} xs={4}>
                        {this.state.unitId && (<IonButton
                            type="submit"
                            size="lg"
                            outline
                            className="mx-2"
                            id="deleteUnit"
                            onClick={this.handleDelete.bind(this, this.props.units[this.state.unitId].propertyId ,this.state.unitId)}
                            data-testid="deleteButton"
                        >
                            <IonIcon size="2x" icon={trashOutline} />
                        </IonButton>)}
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Form onSubmit={this.handleSubmit}>

                            {/* Select Property */}
                            <FormGroup row>
                                <CustomLabel sm={12} md={4} for="propertyId">
                                    Select Property
                                </CustomLabel>

                                <Col style={{maxWidth: '450px'}} md={7} sm={12}>
                                    <CustomInput
                                        type="select"
                                        id="propertyId"
                                        className="mr-2"
                                        name="propertyId"
                                        value={this.state.propertyId}
                                        onChange={this.handleChange}
                                    >
                                        <CustomPropertySelect propertiesArray={this.state.properties}/>
                                    </CustomInput>
                                </Col>
                            </FormGroup>

                            {/* Unit ID/Name */}
                            <FormGroup row>
                                <CustomLabel sm={12} md={4} for="unitName">
                                    Unit ID/Name
                                </CustomLabel>

                                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                                    <InputGroup>
                                        <Input
                                            id="unitName"
                                            name="unitName"
                                            placeholder='Unit ID/Name ...'
                                            value={this.state.unitName}
                                            onChange={this.handleChange}
                                            invalid={this.state.errors.unitName.length > 0}
                                        />
                                        <FormFeedback>{this.state.errors.unitName}</FormFeedback>
                                    </InputGroup>
                                </Col>
                            </FormGroup>

                            {/* Rent Amount */}
                            <FormGroup row>
                                <CustomLabel sm={12} md={4} for="rentAmount">
                                    Rent Amount
                                </CustomLabel>

                                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                                    <InputGroup>
                                        <Input
                                            id="rentAmount"
                                            name="rentAmount"
                                            placeholder='rent amount ...'
                                            value={this.state.rentAmount}
                                            onChange={this.handleChange}
                                            invalid={this.state.errors.rentAmount.length > 0}
                                        />
                                        <FormFeedback>{this.state.errors.rentAmount}</FormFeedback>
                                    </InputGroup>
                                </Col>
                            </FormGroup>

                            {/* Occupied */}
                            {/* TODO: Remove this from Redux and the backend */}
                            {/* <FormGroup row>
                                <CustomLabel sm={12} md={4}>
                                </CustomLabel>

                                <Col  className='ml-3' style={{maxWidth: '450px'}} sm={12} md={7}>
                                    <Input
                                        type="checkbox"
                                        id="occupied"
                                        name="occupied"
                                        value={this.state.occupied}
                                        checked={this.state.occupied}
                                        onChange={this.handleChange}
                                    />
                                    <Label for="occupied" check className="ml-1">
                                        Occupied
                                    </Label>
                                </Col>
                            </FormGroup> */}

                            {/* Tax Rate */}
                            <FormGroup row>
                                <CustomLabel sm={12} md={4} for="rentAmount">
                                    Tax Rate % (optional)
                                </CustomLabel>

                                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                                    <InputGroup>
                                        <Input
                                            id="taxRate"
                                            name="taxRate"
                                            placeholder='tax rate ...'
                                            value={this.state.taxRate}
                                            onChange={this.handleChange}
                                            invalid={this.state.errors.taxRate.length > 0}
                                        />
                                        <FormFeedback>{this.state.errors.taxRate}</FormFeedback>

                                    </InputGroup>
                                    <p>
                                        Residential units tax rate is usually 7.5%.
                                        Commercial units tax rate is usually 16%.
                                    </p>
                                </Col>
                            </FormGroup>

                            <OtherRecurringBills
                                otherRecurringBillsItemOptions={this.state.otherRecurringBillsItemOptions}
                                otherRecurringBillsItems={this.state.otherRecurringBillsItems}
                                handleChangeBillsOptions={this.handleChangeBillsOptions}
                                errors={this.state.errors.otherRecurringBillsItems}
                                onClickAddItem={this.handleAddItem}
                                onClickDeleteItem={this.handleDeleteItem}
                                handleChangeBillsAmount={this.handleChangeBillsAmount}
                                propsItems={this.props.unit ? this.props.unit.otherRecurringBillsItems : null}
                                options={this.props.options}
                                form={"unit"}
                                name={this.state.unitName}
                                propertyBills={this.state.propertyId  ? this.state.properties.find(property => property.propertyId === this.state.propertyId)?.otherRecurringBillsItems : null}
                            />
                            {/*Notes */}
                            <FormGroup row>
                                <CustomLabel sm={12} md={4} for="notes">
                                Notes (optional)
                                </CustomLabel>

                                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                                    <InputGroup>
                                        <Input
                                            id="notes"
                                            name="notes"
                                            type="textarea"
                                            placeholder='notes ...'
                                            value={this.state.notes}
                                            onChange={this.handleChange.bind(this)}
                                            invalid={this.state.errors.notes.length > 0}
                                        />
                                        <FormFeedback>{this.state.errors.notes}</FormFeedback>
                                    </InputGroup>
                                </Col>
                            </FormGroup>

                            {/* Buttons */}
                            <Row className="d-flex mb-4 pt-3 pb-3 border-bottom border-dark justify-content-center">
                                <IonButton type="submit"
                                    id='submitUnit'
                                    className="mx-2 py-1"
                                    style={{ width: "80%" }}
                                    disabled={this.state.propertyId == "" || this.state.numErrors > 0}
                                >
                                    {this.state.unitId?
                                        <span><i className="fa fa-fw fa-refresh mr-1"></i>Update Unit</span>:
                                        <span><i className="fa fa-fw fa-plus mr-1"></i>Add Unit</span>
                                    }
                                </IonButton>

                                {this.state.unitId && (<IonButton
                                    style={{ width: "80%" }}
                                    className="mt-3 py-1"
                                    fill='outline'
                                    onClick={this.handleAddNewUnit.bind(this)}
                                >
                                    <span><i className="fa fa-fw fa-plus mr-1"></i>Add Another Unit</span>
                                </IonButton>)}

                                {!this.state.unitId && (<IonButton
                                    style={{ width: "80%" }}
                                    fill='outline'
                                    className="mx-2 mt-3 py-1"
                                    onClick={this.handleClear.bind(this)}
                                    >
                                    Clear
                                </IonButton>)}

                            </Row>
                        </Form>
                    </Col>
                </Row>

                {/* <Row className="d-flex justify-content-end">
                    {this.state.unitId && this.renderTenantFormButton()}
                </Row> */}
            </Col>
            </Container>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UnitsForm));

